import getParent from '../selectors';
export const IS_SALT_LITE = 'IS_SALT_LITE';

export const getSaltMode = state => getParent(state).mode;

export const isSaltLiteMode = state => getSaltMode(state) === IS_SALT_LITE;
